// extracted by mini-css-extract-plugin
export default {"content_container":"InboundEmailTestPopup_content_container__TlRhS","icon":"InboundEmailTestPopup_icon__tZRsF"};